// extracted by mini-css-extract-plugin
module.exports = {"replaced":"DiffedText_replaced__3q4oR","newText":"DiffedText_newText__9S0Wo"};